/**
 * @author: yanhoup
 * @description: FpxPage
 */

import { Card, ResponsiveGrid } from '@fpxfd/next';
import React, { ReactNode } from 'react';
import styles from './index.module.scss';

interface FpxPageProps {
  /**
   * 页头 面包屑
   */
  header?: ReactNode;
  /**
   * 搜索区
   */
  search?: ReactNode;
  /**
   * 操作区
   */
  action?: ReactNode;
  /**
   * 表格名
   */
  tableTitle?: string;
  /**
   * 表格区
   */
  table?: ReactNode;
  /**
   * 详情
   */
  detail?: ReactNode;
  /**
   * 内容
   */
  content?: ReactNode;
  /**
   * 头部区域
   */
  contentSlot?: ReactNode;
  /**
   *  其他内容
   */
  slot?: ReactNode;
}

const { Cell } = ResponsiveGrid;

const FpxPage = ({ header, search, action, table, detail, tableTitle, content, contentSlot, slot }: FpxPageProps) => {
  return (
    <ResponsiveGrid>
      <Cell colSpan={12}>{header}</Cell>
      <Cell colSpan={12}>
        {contentSlot && contentSlot}
        <Card free className={styles.MainContent}>
          {search && <div className={`${styles.Search} searchform`}>{search}</div>}
          {detail && <div className={styles.Detail}>{detail}</div>}
          {action}
          {tableTitle && <div className={styles.TableTitle}>{tableTitle}</div>}
          {table && table}
          {content && content}
        </Card>
      </Cell>
      {slot && (
        <Cell colSpan={12} className={styles.mt24}>
          {slot}
        </Cell>
      )}
    </ResponsiveGrid>
  );
};

export default FpxPage;
